import { combineReducers } from 'redux'
import { eventReducer } from './eventReducer'
import { consultantReducer } from './consultantReducer'

const rootReducer = combineReducers({
  eventReducer,
  consultantReducer
})

export default rootReducer